/**
 * Berserk: half your clock for a point of bonus on a win. Its own leaf, because
 * the window opens and shuts inside the first two moves of every arena game and
 * that must not re-render the footer.
 */
import {useLiveGame} from '@/Store/liveGameStore';

import {selectShowBerserk} from '../../berserk';

export type BerserkTileModel = {
  /** the window is open (`rail/live/berserk.ts`) */
  showBerserk: boolean;
  onPress: () => void;
};

export function useBerserkTileModel(): BerserkTileModel {
  const showBerserk = useLiveGame(selectShowBerserk);
  const tableId = useLiveGame(s => s.game.tableId);
  const arenaBerserk = useLiveGame(s => s.actions.arenaBerserk);

  return {
    showBerserk,
    onPress: () => arenaBerserk(tableId ?? undefined),
  };
}
